<template>
	<div class="campus">
		<div class="header" style="background: white;">
			<div class="container">
				<div class="flex">
					<div class="logo"><img src="../image/zsdb_logo.png" class="logoImg" style="width:132px"></div>
					<div class="menu" id="nav">
						<ul>
							<li class="menulist"><a @click="gotoHome()" class="">首页</a></li>
							<li class="menulist"><a class="on">招聘公告</a></li>
							<li class="menulist"><a @click="gotoCampus()" class="">校园招聘</a></li>
							<li class="menulist"><a @click="gotoSociety()" class="">社会招聘</a></li>
							<!-- <li class="menulist"><a @click="gotoIntern()" class="">实习生招聘</a></li> -->
						</ul>
					</div>
					<div class="user">
						<div v-show="islogin" class="isLogin" style="display: none;">
							<div @click="gotopersonal()" style="cursor: pointer;"><span>个人中心</span></div>
							<span class="divider">|</span>
							<div @click="exit()" style="cursor: pointer;"><span> 退出</span></div>
						</div>
						<div v-show="unlogin" class="unLogin" style="display: none;">
							<div @click="gotologin()" style="cursor: pointer;"><span>登录</span></div>
							<span class="divider">|</span>
							<div @click="gotoregister()" style="cursor: pointer;"><span>注册</span></div>
						</div>
					</div>
					<el-popover class="ewm" trigger="hover" placement="bottom">
						<img src="../image/ewm.jpg" class="code">
						<img src="../image/icoewm.png" slot="reference" class="ico">
					</el-popover>

				</div>
			</div>
		</div>

		<div class="pagesbanner">
			<img src="../image/xydh01.png" class="dh wow  fadeInLeft" style="left: 0">
			<img src="../image/xydh02.png" class="dh wow  fadeInLeft" style="right: 0">
			<div class="text">
				<h3>招聘公告</h3>
				<p>Recruit Notice</p>
			</div>
		</div>
		<a name="zw" style="position: relative;top: -80px;"></a>
		<div class="nidrpages">
			<div class="list_body">
				<div class="list_empty" v-if="arctict.length == 0">
					<img src="../image/noneposition.png" class="nonepositionimg" /><br />
					<span class="nonepositiontext">暂无公告</span>
				</div>
				<div class="arctict_list_user" v-for="(item,index) in arctict" :key="index"
					@click="gotodetails(item.articleName)">
					<div class="arctict_title_area">
						<span class="arctict_title_list">{{item.articleTitle}}</span>
					</div>
					<div class="arctict_time_area">
						<span class="arctict_time">{{item.articleUpdateTime}}</span>
					</div>
					<el-divider></el-divider>
				</div>
			</div>
		</div>
		<div class="pagination">
			<el-pagination class="pagination_item" layout="prev, pager, next" @current-change="handleCurrentChange"
				:current-page.sync="currentPage" :total="totalPages">
			</el-pagination>
		</div>
		<div class="footer">
			<div class="container">
				<p>&copy 2022 Inc. All Rights Reserved. 中水东北勘测设计研究有限责任公司 版权所有 吉ICP备2022003947号-1
					技术支持：中水东北勘测设计研究有限责任公司数字与智慧工程院
					<br />吉公网安备 22010402001082号
				</p>
			</div>
		</div>
		<backtop></backtop>
	</div>
</template>

<script>
	import jobinfo from "../components/jobinfo.vue"
	import backtop from "../components/backtop.vue"
	import {
		loginstatus,
		Logout,
		queryPosition,
		collectPosition,
		requestPosition,
		queryArticle,
		queryArticleList,
	} from '../api/user.js'
	// @ is an alias to /src
	export default {
		components: {
			jobinfo,
			backtop,
		},

		data() {
			return {
				islogin: false,
				unlogin: false,
				userId: '',
				arctict: [],
				totalPages: null,
				currentPage: 1,
			}
		},

		mounted() {
			loginstatus().then((res) => {
				if (res.code == 200) {
					this.islogin = true;
					this.unlogin = false;
					this.userId = res.data;
				} else if (res.code != 200) {
					this.islogin = false;
					this.unlogin = true;
				}
			});
			queryArticleList({
				currentPage: 1,
				pageCapacity: 10,
			}).then((res) => {
				this.arctict = res.data
				this.totalPages = res.totalPages * 10
			});
		},

		methods: {
			handleCurrentChange() {
				console.log(this.currentPage)
				queryArticleList({
					currentPage: this.currentPage,
					pageCapacity: 10,
				}).then((res) => {
					this.arctict = res.data
					this.totalPages = res.totalPages * 10
				});
			},
			exit() {
				Logout().then((res) => {
					location.reload()
				})
			},
			gotodetails(articleName) {
				this.$router.push({
					path: '/recruitInfo',
					query: {
						articleName: articleName
					}
				})
			},
			gotologin() {
				this.$router.push('/login')
			},
			gotoregister() {
				this.$router.push('/register')
			},
			gotoHome() {
				this.$router.push('/')
			},
			gotoAboutus() {
				this.$router.push('/aboutus/introduce')
			},
			gotoCampus() {
				this.$router.push('/campus')
			},
			gotoSociety() {
				this.$router.push('/society')
			},
			gotoIntern() {
				this.$router.push('/intern')
			},
			gotopersonal() {
				this.$router.push('/personal/resume')
			},
		}
	}

	function timestampToTime(timestamp) {
		timestamp = timestamp ? timestamp : null;
		let date = new Date(timestamp); //时间戳为10位需*1000，时间戳为13位的话不需乘1000
		let Y = date.getFullYear() + '-';
		let M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '-';
		let D = (date.getDate() < 10 ? '0' + date.getDate() : date.getDate()) + ' ';
		return Y + M + D;
	}
</script>

<style scoped>
	@import url(../assets/css/index.css);
	@import url(../assets/css/quillsnowcss.scss);

	.nidrpages {
		min-height: calc(100vh - 460px) !important;
		background-color: white;
		padding-bottom: 35px;
		padding-top: 35px;
	}

	.recruit_Info {
		width: 50%;
		margin-left: 25%;
	}

	.pagesbanner {
		background: url(../image/bannersxs.jpg) top center no-repeat;
	}

	.list_body {
		width: 60%;
		margin-left: 20%;
	}

	.arctict_title_list {
		font-size: 18px;
	}

	.arctict_time {
		font-size: 18px;
	}

	.arctict_time_area {
		width: 30%;
		float: right;
		text-align: right;
	}

	.arctict_title_area {
		width: 70%;
		float: left;
	}

	.arctict_list_user {
		width: 100%;
		padding-top: 5px !important;
		cursor: pointer;
	}

	::v-deep .el-divider {
		margin-top: 35px;
		margin-bottom: 10px;
	}

	.pagination {
		width: 80%;
		margin-left: 10%;
		align-items: center;
		bottom: 35px;
	}

	.pagination_item {
		display: flex;
		justify-content: center;
	}
</style>
